import Block from '@/components/Block';
// import styles from './style.module.less';
// import { useFm, useScreenType } from '@web3/base-hooks';
// import {
//   useCurrentWallet,
//   // useUserInfo,
//   useConnectWalletModal,
// } from '@web3fe/infra';
import { SectionTrade } from './SectionTrade';
// import { SectionInvite } from './SectionInvite';
import { SectionDailyCheckin } from './SectionDailyCheckin';
import { SectionNewUser } from './SectionNewUser';
import { Button } from '@bfe/moly';
import { DirectionrightIcon } from '@bfe/moly-icons';
import IconClock from '@/assets/svg/home/icon-clock-black.svg';
import { DailyCheckIn } from './dialog/DailyCheckIn';
import { useEffect, useMemo, useState } from 'react';
import { getCheckinHistory, postCheckin } from '@/services/home';
import { CheckinHistoryItem } from '@/types';
import useHomeStore from '@/store/home';
import { useFm, useToast, useSetParams } from '@web3/base-hooks';
import { useWallet } from '@/hooks/wallet';
import { Page } from '@/config/track-config';

export const HotTasks = () => {
  const [shwoDailyCheckIn, setShwoDailyCheckIn] = useState(false);
  const [checkInButtonLoading, setCheckInButtonLoading] = useState(false);
  const [checkInData, setCheckInData] = useState<CheckinHistoryItem[]>([]);
  const fm = useFm();

  // const { isMobile } = useScreenType();
  const { supportCommonTask, walletId, walletType } = useWallet();
  // const connectWallet = useConnectWalletModal();

  const paramsBase = useMemo(
    () => ({
      walletId,
      walletType,
    }),
    [walletId, walletType]
  );

  useEffect(() => {
    setShwoDailyCheckIn(false);
    // getAllBalance(true).then((res) => {
    //   console.log('balance', res);
    // });
  }, [walletId]);

  const fetchCheckinData = async () => {
    setCheckInButtonLoading(true);
    try {
      const res = await getCheckinHistory(paramsBase);
      if (res.success && res.result.length) {
        setCheckInData(res.result);
        setShwoDailyCheckIn(true);
      }
    } catch (error) {
      console.log(error);
    }
    setCheckInButtonLoading(false);
  };

  return (
    <Block
      title={fm('howToEarnPointByTask')}
      className=" mt-18"
      titleClass="!text-2xl"
      titleButton={
        supportCommonTask ? (
          <Button
            className="gap-2 h-10 rounded px-4"
            variant={'primary'}
            data-spm-even="Web3UserClick"
            data-spm-data={JSON.stringify({
              page_name: Page.HomePage,
              button_name: 'Web3Points_DailyCheckInEntrance',
            })}
            loading={checkInButtonLoading}
            onClick={fetchCheckinData}
          >
            <IconClock />
            {fm('dailyCheckIn')}
            <DirectionrightIcon
              style={{
                width: 16,
                height: 16,
              }}
            />
          </Button>
        ) : null
      }
    >
      <SectionTrade />
      {/* <SectionInvite /> */}
      {!supportCommonTask && <SectionDailyCheckin />}
      <SectionNewUser />

      <DailyCheckIn
        visble={shwoDailyCheckIn}
        data={checkInData}
        onOk={fetchCheckinData}
        loading={checkInButtonLoading}
        onCancel={() => setShwoDailyCheckIn(false)}
      />
    </Block>
  );
};
